//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../no/TaggedObject.js";
import "../GeometricUtilities/GeometricUtilities.AnchorLocatorBuilder.js";
import "../no/ugmath.js";
let d=[[[1,"Anchor",0,"GeometricUtilities.AnchorLocatorBuilder",0],[0,"AnchorAttachment",1,0],[0,"NumberVertices",0,0]],[[["index"],"GetVertexCoords",{R_:{coords:''}},1,0],[["index","coords"],"SetVertexCoords",{},2,0],[["index"],"GetMidpointCoords",{R_:{coords:''}},1,0],[["index","coords"],"SetMidpointCoords",{},2,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.GeometricUtilities.ShapeFrameBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.ShapeFrameBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricUtilities.ShapeFrameBuilder.AnchorAttachmentType = Object.freeze({
    "None" : "None", "Center" : "Center", "Vertex1" : "Vertex1", "Vertex2" : "Vertex2", "Vertex3" : "Vertex3", "Vertex4" : "Vertex4"});

export default SPLM;